export const MINISTRY_DEFINITIONS = [
  {
    key: "elders",
    label: "Elders / Zaqanym",
    description:
      "Provide mature wisdom, steady counsel, discipline, and recognized weight in safeguarding order, conduct, and direction throughout the Kingdom.",
  },
  {
    key: "counsel",
    label: "Counsel / YuA’aTZYM",
    description:
      "Help weigh matters, refine plans, expose blind spots, and strengthen proposals so matters stand in wisdom and order.",
  },
  {
    key: "overseers",
    label: "Overseers / Paqadym",
    description:
      "Carry charge, ordering, implementation, and accountability across ministries, communities, settlements, projects, and stewardship functions.",
  },
  {
    key: "right_ruling_mediation",
    label: "Shupatym / Right-Ruling and Mediation",
    description:
      "Handle Turah-based settlement of matters through mediation, reconciliation, correction, discipline, appeals, and right-ruling according to the weight of each case.",
  },
  {
    key: "records_genealogy_chronicles",
    label: "Records, Genealogy, and Chronicles / Saparym",
    description:
      "Maintain chronicles, covenants, rulings, testimonies, lineage, inheritance, and Kingdom records for lawful memory and generational continuity.",
  },
  {
    key: "yadah",
    label: "Yadah / Praise Ministry",
    description:
      "Lead orderly thanksgiving, song, instruments, psalms, and gathered service before YaHUaH.",
  },
  {
    key: "feast_appointments",
    label: "Muadym / Feast Appointment Ministry",
    description:
      "Coordinate Muadym, convocations, lodging, meals, schedules, setup, cleanup, and gathering logistics.",
  },
  {
    key: "hospitality_guest_care",
    label: "Hospitality and Guest Care",
    description:
      "Receive guests, support travelers, prepare lodging, coordinate meals, and maintain order for visitors and gatherings.",
  },
  {
    key: "outreach_mission",
    label: "Outreach and Mission Ministry",
    description:
      "Coordinate travel, relief, teaching, community support, and proclamation of the Kingdom of YaHUaH.",
  },
  {
    key: "transitioners_covenant_prep",
    label: "Transitioners and Covenant Preparation Ministry",
    description:
      "Help those entering Kingdom life prepare for settlement, accountability, covenant order, and practical integration.",
  },
  {
    key: "marriage",
    label: "Marriage Ministry",
    description:
      "Strengthen married households through preparation, mentoring, restoration support, and covenant reinforcement.",
  },
  {
    key: "singles",
    label: "Singles Ministry",
    description:
      "Provide guidance, accountability, practical preparation, and strengthening for those not yet in household covenant.",
  },
  {
    key: "mens",
    label: "ANaSHY CHaYaL- Men’s Body",
    description:
      "Shamut 18:21 and Mashaly 27:17. A body for men of character to be sharpened in truth, discipline, brotherhood, provision, protection, craftsmanship, and leadership.",
  },
  {
    key: "womens",
    label: "NaSHY CHaYaL - Women’s Body",
    description:
      "Rut 3:11 and Mashaly 14:1. A body for capable women of character to build in wisdom, household order, stewardship, service, and steadfast conduct under headship.",
  },
  {
    key: "ban_yahuah",
    label: "NA’aRYM Ba’DaRaK (Ban YaHUaH)",
    description:
      "Prepare young men through mentorship, discipline, service, trades exposure, and leadership development.",
  },
  {
    key: "bat_yahuah",
    label: "NA’aRUT Ba’DaRaK (Bat YaHUaH)",
    description:
      "Prepare young women through mentorship, wisdom, service, practical training, and household preparation.",
  },
  {
    key: "youth",
    label: "TaP Ba'DaRaK Youth Ministry",
    description:
      "Mashaly 22:6. A body for the little ones to be formed early in the Way through instruction, discipline, practical learning, and steady care.",
  },
  {
    key: "research_discovery_scroll_house",
    label: "Research, Discovery, and Scroll House",
    description:
      "Preserve and investigate manuscripts, archives, tongues, inscriptions, maps, ruins, scrolls, and written knowledge.",
  },
  {
    key: "communications_media_technology",
    label: "Communications, Media, and Technology Systems",
    description:
      "Oversee publications, notices, broadcasts, websites, recording, production, archives, networks, software, radio, and backup communication systems.",
  },
  {
    key: "treasury_stewards",
    label: "Treasury Stewards",
    description:
      "Oversee offerings, resources, distributions, storehouses, honest accounting, and transparent stewardship reporting.",
  },
  {
    key: "internal_exchange_weights_measures",
    label: "Internal Exchange, Weights, and Measures",
    description:
      "Guard honest weights, measures, barter records, internal exchange, inventories, fair distribution, and non-usury stewardship.",
  },
  {
    key: "land_stewards",
    label: "Land Stewards",
    description:
      "Oversee inheritance, boundaries, settlement order, land use, housing areas, and land-based stewardship.",
  },
  {
    key: "water_stewards",
    label: "Water Stewards",
    description:
      "Oversee wells, springs, purification, storage, irrigation, distribution, and protection of water sources.",
  },
  {
    key: "malach_minerals_mining",
    label: "Salt / MaLaCH, Minerals, and Mining",
    description:
      "Oversee salt, quarrying, clay, lime, ores, minerals, and raw material stewardship for Kingdom use.",
  },
  {
    key: "crop_seed_storehouse",
    label: "Crop, Seed, and Storehouse Ministry",
    description:
      "Oversee farming, orchards, gardens, seed banks, soil care, preservation, storage, distribution, and food reserves.",
  },
  {
    key: "animal_husbandry_fishing_storehouse",
    label: "Animal Husbandry, Fishing, and Storehouse Ministry",
    description:
      "Oversee livestock, poultry, bees, fishing, animal care, preservation, and animal-based food reserves.",
  },
  {
    key: "health_healing_birth_infant",
    label: "Health, Healing, Mothers, Birth, and Infant Care",
    description:
      "Provide herbal care, medicine, midwifery, emergency response, pregnancy support, birth care, postpartum care, and infant support.",
  },
  {
    key: "sanitation_cleanliness",
    label: "Sanitation and Cleanliness Ministry",
    description:
      "Oversee waste management, composting, laundry, bathhouses, pest control, water protection, and public cleanliness.",
  },
  {
    key: "burial_mourning",
    label: "Burial and Mourning Care",
    description:
      "Provide burial preparation, mourning support, household assistance, death records, and care during times of loss.",
  },
  {
    key: "warfare_watchmen",
    label: "Warfare and Watchmen",
    description:
      "Carry intercession, spiritual watchfulness, warning duties, readiness counsel, defense awareness, and alerting responsibilities.",
  },
  {
    key: "shamarym",
    label: "Shamarym / Guardians",
    description:
      "Serve as gatekeepers, escorts, patrols, event security, safety teams, emergency response helpers, and protectors of the assembly.",
  },
  {
    key: "infrastructure_transportation_emergency",
    label: "Infrastructure, Transportation, Navigation, and Emergency Logistics",
    description:
      "Oversee routes, roads, bridges, drainage, shelters, supply lines, evacuation paths, movement systems, recovery coordination, and common works planning.",
  },
  {
    key: "off_grid_energy_fuel",
    label: "Off-Grid Systems and Energy/Fuel Stewards",
    description:
      "Develop low-tech and off-grid systems for lighting, heating, cooling, fuel, firewood, oil, mechanical power, and continuity during disruptions.",
  },
  {
    key: "pilots_captains",
    label: "Pilots and Captains",
    description:
      "Operate and maintain aircraft, boats, ships, navigation systems, transport routes, evacuation capability, and long-distance movement.",
  },
  {
    key: "tools_mechanical",
    label: "Tools and Mechanical Works",
    description:
      "Maintain tools, mills, presses, pumps, carts, wagons, gears, pulleys, and repair systems needed for daily Kingdom function.",
  },
  {
    key: "metal_workers",
    label: "Metal Workers",
    description:
      "Produce and maintain tools, metal works, fabricated parts, armor, and repair systems.",
  },
  {
    key: "stone_masons",
    label: "Stone Masons",
    description:
      "Build and maintain foundations, wells, walls, ovens, bridges, roads, drainage works, and stone structures.",
  },
  {
    key: "forestry_woodworkers_carpentry",
    label: "Forestry, Woodworkers, and Carpentry",
    description:
      "Manage timber resources and produce lumber, tools, shelters, carts, furniture, fuel, and wood structures.",
  },
  {
    key: "textile_garment",
    label: "Textile and Garment Workers",
    description:
      "Produce clothing, blankets, coverings, tents, spun goods, woven goods, dyed fabrics, and repairs.",
  },
  {
    key: "leather_workers",
    label: "Leather Workers",
    description:
      "Produce footwear, belts, bags, harnesses, sheaths, waterskins, straps, and leather goods.",
  },
  {
    key: "potters_clay",
    label: "Potters and Clay Workers",
    description:
      "Produce vessels, storage containers, bricks, tiles, ovens, clay pipes, and clay infrastructure works.",
  },
  {
    key: "manufacturing_housewares",
    label: "Manufacturing and Housewares",
    description:
      "Produce soap, vinegar, candles, cordage, brushes, paper, writing tools, containers, and daily-use necessities.",
  },
];

export const MINISTRY_LIST = MINISTRY_DEFINITIONS.map((m) => m.key);

export const MINISTRY_LABELS = MINISTRY_DEFINITIONS.reduce((acc, ministry) => {
  acc[ministry.key] = ministry.label;
  return acc;
}, {});

export const MINISTRY_DESCRIPTIONS = MINISTRY_DEFINITIONS.reduce((acc, ministry) => {
  acc[ministry.key] = ministry.description;
  return acc;
}, {});

export const LEGACY_MINISTRY_KEY_MAP = {
  counsel: "counsel",
  counselor: "counsel",
  counselors: "counsel",
  yuaatzym: "counsel",
  "Counsel": "counsel",
  "Counselors": "counsel",
  "Counsel / YuA’aTZYM": "counsel",

  internal_exchange: "internal_exchange_weights_measures",
  internal_measures: "internal_exchange_weights_measures",
  weights_measures: "internal_exchange_weights_measures",
  weights_and_measures: "internal_exchange_weights_measures",
  honest_weights_measures: "internal_exchange_weights_measures",
  barter_records: "internal_exchange_weights_measures",
  "Internal Exchange": "internal_exchange_weights_measures",
  "Internal Measures": "internal_exchange_weights_measures",
  "Weights and Measures": "internal_exchange_weights_measures",
  "Internal Exchange, Weights, and Measures": "internal_exchange_weights_measures",

  record_keepers: "records_genealogy_chronicles",
  genealogy_keepers: "records_genealogy_chronicles",
  genealogies: "records_genealogy_chronicles",
  "Record Keepers": "records_genealogy_chronicles",
  "Genealogy Keepers": "records_genealogy_chronicles",
  "Genealogies": "records_genealogy_chronicles",

  food_storehouse: "crop_seed_storehouse",
  food_farm: "crop_seed_storehouse",
  meals_nutrition: "crop_seed_storehouse",
  seed_agriculture: "crop_seed_storehouse",
  "Food and Storehouse Ministry": "crop_seed_storehouse",
  "Food/Farm": "crop_seed_storehouse",
  "Overseers of Meals/Nutritionist": "crop_seed_storehouse",
  "Seed and Agricultural Preservation": "crop_seed_storehouse",

  animal_husbandry_fishing: "animal_husbandry_fishing_storehouse",
  "Animal Husbandry and Fishing Ministry": "animal_husbandry_fishing_storehouse",

  health_healing: "health_healing_birth_infant",
  mothers_birth_infants: "health_healing_birth_infant",
  health: "health_healing_birth_infant",
  ama: "health_healing_birth_infant",
  "Health": "health_healing_birth_infant",
  "Health and Healing Ministry": "health_healing_birth_infant",
  "Mothers, Birth, and Infant Care": "health_healing_birth_infant",
  "Ama": "health_healing_birth_infant",

  research_discovery: "research_discovery_scroll_house",
  knowledge_scroll_house: "research_discovery_scroll_house",
  knowledge_apprenticeship: "research_discovery_scroll_house",
  research: "research_discovery_scroll_house",
  "Research": "research_discovery_scroll_house",
  "Research and Discovery Ministry": "research_discovery_scroll_house",
  "Knowledge and Scroll House": "research_discovery_scroll_house",
  "Knowledge and Apprenticeship Ministry": "research_discovery_scroll_house",

  transitioners: "transitioners_covenant_prep",
  "Transitioners": "transitioners_covenant_prep",
  "Transitioners Ministry": "transitioners_covenant_prep",

  news_communications: "communications_media_technology",
  audio_visual: "communications_media_technology",
  communications_signal: "communications_media_technology",
  technology_networks: "communications_media_technology",
  news_media: "communications_media_technology",
  av: "communications_media_technology",
  "News and Communications": "communications_media_technology",
  "News & Media": "communications_media_technology",
  "Audio-Visual Ministry": "communications_media_technology",
  "A/V": "communications_media_technology",
  "Communications and Signal Ministry": "communications_media_technology",
  "Technology and Network Systems": "communications_media_technology",

  infrastructure_works: "infrastructure_transportation_emergency",
  transportation_logistics: "infrastructure_transportation_emergency",
  navigation_wayfinding: "infrastructure_transportation_emergency",
  emergency_response: "infrastructure_transportation_emergency",
  craftsmen_builders: "infrastructure_transportation_emergency",
  "Infrastructure and Works Ministry": "infrastructure_transportation_emergency",
  "Transportation and Logistics": "infrastructure_transportation_emergency",
  "Navigation and Wayfinding": "infrastructure_transportation_emergency",
  "Emergency Response Ministry": "infrastructure_transportation_emergency",
  "Craftsmen and Builders": "infrastructure_transportation_emergency",

  off_grid_systems: "off_grid_energy_fuel",
  energy_fuel: "off_grid_energy_fuel",
  "Off-Grid Systems Ministry": "off_grid_energy_fuel",
  "Energy and Fuel Stewards": "off_grid_energy_fuel",

  forestry_woodworkers: "forestry_woodworkers_carpentry",
  "Forestry and Woodworkers": "forestry_woodworkers_carpentry",

  warfare_intercession: "warfare_watchmen",
  feasts: "feast_appointments",
  outreach_missions: "outreach_mission",
  bayt_yahuah: "bat_yahuah",
  minors: "youth",
  money: "treasury_stewards",
  land: "land_stewards",
  force_security: "shamarym",

  ...Object.fromEntries(MINISTRY_LIST.map((key) => [key, key])),
  ...Object.fromEntries(
    MINISTRY_DEFINITIONS.map((ministry) => [ministry.label, ministry.key])
  ),
};

export function normalizeMinistryKey(value) {
  if (!value) return null;

  const rawValue = String(value).trim();

  if (MINISTRY_LIST.includes(rawValue)) {
    return rawValue;
  }

  return LEGACY_MINISTRY_KEY_MAP[rawValue] || null;
}

export function normalizeMinistryKeys(values) {
  if (!Array.isArray(values)) return [];

  const normalized = [];

  values.forEach((value) => {
    const key = normalizeMinistryKey(value);

    if (key && !normalized.includes(key)) {
      normalized.push(key);
    }
  });

  return normalized;
}

export function getMinistryLabel(value) {
  const key = normalizeMinistryKey(value) || value;
  return MINISTRY_LABELS[key] || String(value);
}

export function getMinistryDescription(value) {
  const key = normalizeMinistryKey(value) || value;
  return MINISTRY_DESCRIPTIONS[key] || "";
}

export const ADMIN_SCOPE_DEFINITIONS = [
  {
    key: "portal_operations",
    label: "Portal Administration",
    description:
      "Allows an admin to manage portal settings, portal access areas, and portal-facing administration tools.",
  },
  {
    key: "subscriber_assets",
    label: "Subscriber Assets",
    description:
      "Allows an admin to publish and manage subscriber downloads, monthly assets, media files, and gated subscriber resources.",
  },
  {
    key: "commerce_products",
    label: "Products and Store",
    description:
      "Allows an admin to create, edit, refresh, and manage products, music products, and store listings.",
  },
  {
    key: "subscriber_accounts",
    label: "Subscriber Accounts",
    description:
      "Allows an admin to view and manage subscriber tiers, subscriber status, and subscriber access issues.",
  },
  {
    key: "submissions_review",
    label: "Submissions Review",
    description:
      "Allows an admin to view, review, and manage YaSHaRUN applications, leads, and submitted forms.",
  },
  {
    key: "website_content",
    label: "Website Content",
    description:
      "Allows an admin to help manage public website content, page updates, and public-facing information.",
  },
  {
    key: "media_library",
    label: "Media Library",
    description:
      "Allows an admin to manage uploaded files, media resources, images, documents, and media records.",
  },
  {
    key: "payments_claims",
    label: "Payments and Claims",
    description:
      "Allows an admin to review payment-related records, patron claims, order issues, and claim follow-up.",
  },
];

export const EXTENDED_ADMIN_SCOPES = [
  { key: "email_communications", label: "Email Communications", description: "Manage captured emails, topic preferences, newsletters and mailing notifications." },
  { key: "records_administration", label: "Records Label", description: "Review artist inquiries and administer record label workflows." },
  { key: "publishing_administration", label: "Publishing", description: "Review writers, compositions and publishing workflows." },
  { key: "live_administration", label: "Yashar’al Live", description: "Manage broadcasting operations and Live-related notifications." },
  { key: "music_subscriber_administration", label: "Music Subscribers", description: "Handle subscriber-only releases, media access, and subscriber inquiries." },
  { key: "merch_administration", label: "Merchandise", description: "Manage merchandise and related inquiry notifications." },
];

export const ALL_ADMIN_SCOPES = [
  ...ADMIN_SCOPE_DEFINITIONS,
  ...EXTENDED_ADMIN_SCOPES,
  ...MINISTRY_DEFINITIONS,
];

export const ALL_PERMISSIONS = [
  { key: "records:read", label: "Read Records label", description: "Scoped administrator capability for read records label." },
  { key: "records:manage", label: "Manage Records label", description: "Scoped administrator capability for manage records label." },
  { key: "publishing:read", label: "Read publishing", description: "Scoped administrator capability for read publishing." },
  { key: "publishing:manage", label: "Manage publishing", description: "Scoped administrator capability for manage publishing." },
  { key: "live:read", label: "Read Yashar’al Live", description: "Scoped administrator capability for read yashar’al live." },
  { key: "live:manage", label: "Manage Yashar’al Live", description: "Scoped administrator capability for manage yashar’al live." },
  { key: "email_campaigns:read", label: "Read email campaigns", description: "Scoped administrator capability for read email campaigns." },
  { key: "email_campaigns:manage", label: "Manage email campaigns", description: "Scoped administrator capability for manage email campaigns." },
  {
    key: "users:read",
    label: "Users: Read",
    description:
      "Can view user profiles in the admin panel. This does not allow changing users.",
  },
  {
    key: "users:manage",
    label: "Users: Manage",
    description:
      "Can create users, edit users, assign ministries, and manage user records according to assigned admin scopes.",
  },
  {
    key: "roles:manage",
    label: "Roles: Manage",
    description:
      "Can assign or remove roles such as national, subscriber, or admin. This should be limited to trusted administrators.",
  },
  {
    key: "permissions:manage",
    label: "Permissions: Manage",
    description:
      "Can assign or remove admin permissions. This should be limited because it controls what other admins can do.",
  },
  {
    key: "ministries:read",
    label: "Ministries: Read",
    description:
      "Can view ministry assignments, ministry members, and ministry workspace information.",
  },
  {
    key: "ministries:manage",
    label: "Ministries: Manage",
    description:
      "Can assign or remove ministries from users, but only within the admin scopes permitted to that admin.",
  },
  {
    key: "subscriptions:read",
    label: "Subscriptions: Read",
    description:
      "Can view subscriber status, tiers, and subscription-related information.",
  },
  {
    key: "subscriptions:manage",
    label: "Subscriptions: Manage",
    description:
      "Can change subscriber tier/status and manage subscription access issues.",
  },
  {
    key: "assets:read",
    label: "Assets: Read",
    description:
      "Can view subscriber assets, downloads, files, and gated resources.",
  },
  {
    key: "assets:manage",
    label: "Assets: Manage",
    description:
      "Can create, edit, publish, or delete subscriber assets and media resources.",
  },
  {
    key: "products:read",
    label: "Products: Read",
    description:
      "Can view product records, music products, and store listing records.",
  },
  {
    key: "products:manage",
    label: "Products: Manage",
    description:
      "Can create, edit, refresh, seed, or delete product and store listing records.",
  },
  {
    key: "portal:read",
    label: "Portal: Read",
    description:
      "Can view portal administration areas and portal-related records.",
  },
  {
    key: "portal:manage",
    label: "Portal: Manage",
    description:
      "Can manage portal operations and portal-facing administration tools.",
  },
  {
    key: "submissions:read",
    label: "Submissions: Read",
    description:
      "Can view leads, YaSHaRUN applications, contact submissions, and submitted forms.",
  },
  {
    key: "submissions:manage",
    label: "Submissions: Manage",
    description:
      "Can review, update, export, or manage submitted forms and YaSHaRUN applications.",
  },
];
